import { BRAND_LIST, CountryLanguageSwitcher, Languages } from 'typings'
import * as Typings from '../typings'

const GermanyLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'de',

  LONG_NAME: 'Germany',
  SHORT_NAME: 'DE',
  DISPLAY_COUNTRY: 'Deutschland',
  SHOW_TIME_IN_MILITARY: true,
  LANGUAGES: {
    DE: 'de',
    EN: 'en',
  },
  [BRAND_LIST.UQ]: {
    [Languages.DE]: {
      LANGUAGE_CODE: 'de',
      DISPLAY_NAME: 'Deutschland (Deutsch)',
      CONTACT_US_URL: 'https://faq-de.uniqlo.com/',
      HOME_PAGE_URL: 'https://www.uniqlo.com/de/de',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/de/de/',
      TERMS_OF_USE_URL:
        'https://faq-de.uniqlo.com/pkb_Home_UQ_DE?l=de&c=category_uq_eu_dk_se%3ARenew_UQDE_C7_3',
      PRIVACY_POLICY_URL:
        'https://faq-de.uniqlo.com/pkb_Home_UQ_DE?l=de&c=category_uq_eu_dk_se%3ARenew_UQDE_C7_2',
      AREAS: {
        '1': 'Baden-Württemberg',
        '2': 'Bayern',
        '3': 'Berlin',
        '4': 'Brandenburg',
        '5': 'Bremen',
        '6': 'Hamburg',
        '7': 'Hessen',
        '8': 'Niedersachsen',
        '9': 'Mecklenburg-Vorpommern',
        '10': 'Nordrhein-Westfalen',
        '11': 'Rheinland-Pfalz',
        '12': 'Saarland',
        '13': 'Sachsen',
        '14': 'Sachsen-Anhalt',
        '15': 'Schleswig-Holstein',
        '16': 'Thüringen',
      },
    },
    [Languages.EN]: {
      LANGUAGE_CODE: 'en',
      DISPLAY_NAME: 'Deutschland (Deutsch)',
      HOME_PAGE_URL: 'https://www.uniqlo.com/de/en',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/de/en/',
      CONTACT_US_URL: 'https://faq-de.uniqlo.com/pkb_Home_UQ_DE?l=en_US',
      TERMS_OF_USE_URL:
        'https://faq-de.uniqlo.com/pkb_Home_UQ_DE?l=en_US&c=category_uq_eu_dk_se%3ARenew_UQDE_C7_3',
      PRIVACY_POLICY_URL:
        'https://faq-de.uniqlo.com/pkb_Home_UQ_DE?l=en_US&c=category_uq_eu_dk_se%3ARenew_UQDE_C7_2',
      AREAS: {
        '1': 'Baden-Württemberg',
        '2': 'Bavaria',
        '3': 'Berlin',
        '4': 'Branburg',
        '5': 'Bremen',
        '6': 'Hamburg',
        '7': 'Hesse',
        '8': 'Lower Saxony',
        '9': 'Mecklenburg-Vorpommern',
        '10': 'North Rhine-Westphalia',
        '11': 'Rhineland-Palatinate',
        '12': 'Saarland',
        '13': 'Saxony',
        '14': 'Saxony-Anhalt',
        '15': 'Schleswig-Holstein',
        '16': 'Thuringia',
      },
    },
  },
  GEO_COORDINATES: {
    INITIAL_LATITUDE: 51.1758057,
    INITIAL_LONGITUDE: 10.4541194,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  MAP_URL: 'https://www.uniqlo.com/de/de/content/Stores_Landing_Germany.html',
  POSTCODE_FORMAT: /^[0-9]{5}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },
  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default GermanyLocale
